module.exports = __webpack_public_path__ + "assets/img/_Novo RDR_Wellness Pool_RGB_lr.9f363913.jpg";